import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { SERVER, LOGON_INFO } from "../app.constants";
import { Car } from "./car.service";
import { CommonService } from "../app.service";
import { StringifyOptions } from "querystring";


@Injectable()
export class UserService {

    login_user_id: string;
    login_comp_id: string;
    login_car_id: number;

    constructor(
        private _htc: HttpClient,
        private commonService: CommonService
    ) {
        this.login_user_id = LOGON_INFO.USER_ID;
        this.login_comp_id = LOGON_INFO.COMP_ID;
        this.login_car_id = LOGON_INFO.CAR_ID;
    }

    checkUseridDuplicate(userid: string): Observable<User[]> {
        return this._htc.get<User[]>(SERVER.baseURL+'/userid-check/'+userid+'/');
    }

    getUserInfo(userid: string): Observable<User> {
        return this._htc.get<User>(SERVER.baseURL+'/user-info/'+userid+'/');
    }

    //ユーザーリストを取得
    getUserList(page: number, isDeleteDriver: boolean): Observable<User[]> {
        let params = new HttpParams().set('page', page.toString());
        //Get user list from REST API (responseはdefaultでjson形式だが、User[]でキャストする)
        return this._htc.get<User[]>(SERVER.baseURL+'/user-list/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteDriver.toString()+'/'+LOGON_INFO.USER_ID, {params: params});
    }

    //ドライバーリストを取得
    getDriverList(page: number, isDeleteDriver: boolean, isLargeResult: boolean): Observable<Driver[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Driver[]>(SERVER.baseURL+'/driver-list/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteDriver.toString()+'/'+isLargeResult.toString()+'/'+LOGON_INFO.USER_ID, {params: params});
    }

    getUserCompanyInfo(userid: string): Observable<any> {
        return this._htc.get<any>(SERVER.baseURL+'/user-company-info/'+userid+'/');
    }

    //ユーザーを新規登録
    registUser(user: User): Observable<User> {
        this.setParam(user);
        return this._htc.post<User>(SERVER.baseURL+'/user-regist/', JSON.stringify(user));
    }

    registDriver(driver: Driver): Observable<Driver> {
        this.setDriverParam(driver);
        return this._htc.post<Driver>(SERVER.baseURL+'/driver-regist/', JSON.stringify(driver));
    }

    //ユーザー情報を更新
    updateUser(user: User): Observable<User> {
        this.setParam(user);
        // if (user.password == undefined) {
            return this._htc.put<User>(SERVER.baseURL+'/user-update/'+user.userid+'/', JSON.stringify(user));
        // } else {
        //     return this._htc.put<User>(SERVER.baseURL+'/user-update-with-password/'+user.userid+'/', JSON.stringify(user));
        // }
    }

    updateDriver(driver: Driver): Observable<Driver> {
        this.setDriverParam(driver);
        return this._htc.put<Driver>(SERVER.baseURL+'/driver-update/'+driver.id+'/', JSON.stringify(driver));
    }

    //ユーザーを削除
    deleteUser(user: User) {
        let param = {
            userid: user.userid,
            div: user.div,
            update_id: this.login_user_id
        };
        return this._htc.put<User>(SERVER.baseURL+'/user-delete/'+user.userid+'/', JSON.stringify(param));
    }

    deleteDriver(driver: Driver) {
        // let param = {
        //     update_id: this.login_user_id
        // };
        return this._htc.put<Driver>(SERVER.baseURL+'/driver-delete/'+driver.id+'/', JSON.stringify({update_id: this.login_user_id}));
    }

    updatePassword(password: string) {
        return this._htc.put<User>(SERVER.baseURL+'/user-update-password/'+this.login_user_id+'/', JSON.stringify({password: password, update_id: this.login_user_id}));
    }


    private setParam(user: User) {
        user.div = '2';  //2:配車担当者
        user.create_id = this.login_user_id;
        user.update_id = this.login_user_id;
        // user.address_lat  = this.commonService.decimalRound(user.address_lat, 6);
        // user.address_lng = this.commonService.decimalRound(user.address_lng, 6);
    }

    private setDriverParam(driver: Driver) {
        driver.create_id = this.login_user_id;
        driver.update_id = this.login_user_id;
        driver.license_expire_date = driver.license_expire_date.formatted.split('/').join('-');
    }

}



export class User {
    id: number;
    div: string;
    userid: string;
    password: string;
    passwordConfirm: string;
    group_name: string;
    comp_id: string;
    comp_type: string;
    comp_type_name: string;
    comp_name: string;
    name: string;
    email: string;
    emailConfirm: string;
    tel: string;
    mobile: string;
    zipcode: string;
    address: string;
    address_detail: string;
    address_lat: number;
    address_lng: number;
    etc: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_name: string;
    update_date: Date;
}

export class Driver {
    id: number;
    comp_id: string;
    comp_type: string;
    comp_type_name: string;
    group_name: string;
    comp_name: string;
    parent_comp_id: string;
    name: string;
    name_kana: string;
    tel: string;
    etc: string;
    is_active: boolean;
    license_expire_date: any;
    license_type: string;
    license_type_name: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_name: string;
    update_date: Date;

    car_nos: string;
    car_no_1: string;
    car_no_2: string;
    car_no_3: string;
}

export class Password {
    password: string;
    passwordConfirm: string;
}



// WEBPACK FOOTER //
// ./src/app/member-kanri/user.service.ts